module.exports = "div.cke5-read-only-toolbar-overlay{position:absolute;display:block;width:100%;z-index:1;background-color:hsla(0,0%,86.3%,.4)}"